import * as Common from "../../commons/common"

export class SheetActivity{
  id: number = 0
  student_id: number = 0
  page: number = 0
  angle: number = 0
  baseWidth: number = 0
  baseHeight: number = 0
  baseWidthCache: number = 0
  baseHeightCache: number = 0
  sheetActivityHoseiPositions: SheetActivityHoseiPosition[] = []
  correctHoseiPositions: CorrectHoseiPosition[] = []
  is_exists_backup_image: boolean
  created_at: string
  x: number = 0
  y: number = 0
  imageUrl: string = null;
  imageSrc: string = null;

  constructor(sa: any, sheet_activity_hosei_positions: any[], correct_hosei_positions: any[], baseWidth: number, baseHeight: number){
    this.id = sa.id;
    this.student_id = sa.student_id;
    this.page = sa.page;
    this.sheetActivityHoseiPositions = sheet_activity_hosei_positions.filter((x: any) => x.sheet_activity_id == sa.id).map((x: any) => new SheetActivityHoseiPosition(x, baseWidth, baseHeight));
    this.correctHoseiPositions = correct_hosei_positions.filter((x: any) => x.page == this.page).map((x: any) => new CorrectHoseiPosition(x));
    this.is_exists_backup_image = sa.is_exists_backup_image;
    this.created_at = Common.formatDate(sa.created_at, "M月D日 HH:mm");
  }
 }

export class Examinee{
  id: number = 0
  student_no: number = 0
  absent_flg: boolean = false
  student_no_character: string = ""
  student_name: string = ""
  room_name: string = ""
  sheetActivities: SheetActivity[] = new Array<SheetActivity>()
  isAbsent: boolean = false
  email: string = ""
  uploaded_at: string = ""
  isHoseiTarget: boolean = false

  constructor(examinee: any, sheet_activities: any[], sheet_activity_hosei_positions: any[], correct_hosei_positions: any[], baseWidth: number, baseHeight: number){
    this.id = examinee.id;
    this.student_no = examinee.student_no;
    this.absent_flg = examinee.absent_flg;
    this.student_no_character = examinee.student_no_character;
    this.student_name = examinee.student_name;
    this.room_name = examinee.room_name;
    this.email = examinee.email;
    
    const sheetActivities = new Array<SheetActivity>();
    sheet_activities.filter((x: any) => x.student_id == this.student_no).forEach((x: any) => {
      sheetActivities.push(new SheetActivity(x, sheet_activity_hosei_positions, correct_hosei_positions, baseWidth, baseHeight));
    });
    
    this.sheetActivities = sheetActivities.sort((a: SheetActivity, b: SheetActivity) => a.page < b.page ? -1 : 1);

    if(this.sheetActivities.length > 0){
      this.uploaded_at = this.sheetActivities[0].created_at;
    }
  }
}

export class SheetActivityHoseiPosition {
  id: number
  sheet_activity_id: number
  pos_no: number
  rim: number[]
  pos_name: string

  constructor(x: any, baseWidth: number, baseHeight: number){
    this.id = x.id;
    this.sheet_activity_id = x.sheet_activity_id;
    this.pos_no = x.pos_no;
    this.rim = x.rim;

    if(this.pos_no == 1){
      this.pos_name = "左上";
    }else if(this.pos_no == 2){
      this.pos_name = "左下";
    }else if(this.pos_no == 3){
      this.pos_name = "右下";
    }else if(this.pos_no == 4){
      this.pos_name = "右上";
    }

    if(x.rim != null){
      this.rim = x.rim;
    }else{
      const margin = 70;
      if(this.pos_no == 1){
        this.rim = [margin, margin];
      }else if(this.pos_no == 2){
        this.rim = [margin, baseHeight - margin];
      }else if(this.pos_no == 3){
        this.rim = [baseWidth - margin, baseHeight - margin];
      }else if(this.pos_no == 4){
        this.rim = [baseWidth - margin, margin];
      }
    }
  }
}

export class CorrectHoseiPosition {
  id: number
  page: number
  pos_no: number
  rim: number[]

  constructor(x: any){
    this.id = x.id;
    this.page = x.page;
    this.pos_no = x.pos_no;
    this.rim = x.rim;
  }
}

export class SheetField {
  id: number
  page: number
  rim: number[]

  constructor(x: any){
    this.id = x.id;
    this.page = x.page;
    this.rim = x.rim;
  }
}
